import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/community/[id]/page.tsx");
